import { graphql, useFragment } from 'react-relay';
import { filterNulls } from 'dibs-ts-utils/exports/filterNulls.ts';
import {
    type useSwatches_item$key,
    type useSwatches_item$data,
} from './__generated__/useSwatches_item.graphql.ts';
import { type ArrayElement } from 'dibs-ts-utils/exports/ArrayElement.ts';

const itemFragment = graphql`
    fragment useSwatches_item on Item {
        isMultiSku
        isRingItem
        variableAttributes {
            serviceId
            variableAttributeData {
                swatchSort {
                    swatch {
                        serviceId
                        displayName
                        imageUrl
                    }
                }
            }
        }
    }
`;

type Swatch = NonNullable<
    NonNullable<
        ArrayElement<
            NonNullable<
                NonNullable<
                    ArrayElement<useSwatches_item$data['variableAttributes']>
                >['variableAttributeData']
            >['swatchSort']
        >
    >['swatch']
>;

type Props = { item: useSwatches_item$key };

export const useSwatches = ({ item: itemRef }: Props): Swatch[] => {
    const item = useFragment(itemFragment, itemRef);
    const isMultiSku = item?.isMultiSku;
    const isRingItem = item?.isRingItem;
    const swatches =
        item?.variableAttributes?.[0]?.variableAttributeData?.swatchSort?.filter(filterNulls) || [];
    if (isRingItem || !isMultiSku || !swatches.length) {
        return [];
    }
    return swatches
        .map(({ swatch }) => {
            if (!swatch) {
                return null;
            }
            const { serviceId, displayName, imageUrl } = swatch;
            return { serviceId, displayName, imageUrl };
        })
        .filter(filterNulls);
};
